module.exports = __webpack_public_path__ + "static/media/promotional_menu.c904033c.svg";